<app-navbar title="Organizacje">
	<button mat-raised-button routerLink="./add" color="primary" class="me-4"><i class="fas fa-plus"></i> Dodaj</button>
</app-navbar>
<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>
<app-organization-filters
	userFilters="product"
	(selected)="filtersSelected($event)"
	[isOskar]="parameters.isOskar"
	[isActive]="parameters.isActive"
	[locations]="parameters.locations"
	[forceFilters]="{ limit: 9999 }"
></app-organization-filters>
<ng-container *ngIf="showTable">
	<mat-table
		[dataSource]="matData"
		matSort
		matSortActive="id"
		matSortDirection="asc"
		grouping="false"
		cdkDropList
		cdkDropListDisabled="true"
	>
		<ng-container matColumnDef="lp">
			<mat-header-cell *matHeaderCellDef>LP</mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index">
				{{ i + 1 }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="shortName">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Skrócona nazwa </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.shortName }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Pełna nazwa </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="sellCategory">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Kategoria sprzedaży </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ matchSellCategory(element.sellCategory) }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="nip">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="d-flex justify-content-center">
				NIP
			</mat-header-cell>
			<mat-cell *matCellDef="let element" class="d-flex justify-content-center">{{ element.nip }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="merlinxCode">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="d-flex justify-content-center">
				Kod MerlinX
			</mat-header-cell>
			<mat-cell *matCellDef="let element" class="d-flex justify-content-center">{{
				element.codeMerlinx
			}}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="isOskar">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="d-flex justify-content-center">
				Grupa Oskar?
			</mat-header-cell>
			<mat-cell *matCellDef="let element" class="d-flex justify-content-center"
				><i
					class="fa-solid"
					[ngClass]="{
						'fa-circle-check green': element.isOskar,
						'fa-circle-xmark red': !element.isOskar,
					}"
				></i
			></mat-cell>
		</ng-container>
		<ng-container matColumnDef="isActive">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="d-flex justify-content-center">
				Aktywne?
			</mat-header-cell>
			<mat-cell *matCellDef="let element" class="d-flex justify-content-center"
				><i
					class="fa-solid"
					[ngClass]="{
						'fa-circle-check green': element.isActive,
						'fa-circle-xmark red': !element.isActive,
					}"
				></i
			></mat-cell>
		</ng-container>
		<ng-container matColumnDef="nawigatorID">
			<mat-header-cell *matHeaderCellDef mat-sort-header> ID Nawigatora </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.nawigatorID }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<button mat-raised-button color="primary" routerLink="/organization/{{ element.id }}/">Edytuj</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>
	<mat-paginator
		class="fixed-bottom"
		style="z-index: 0"
		[pageSizeOptions]="[20, 30, 50]"
		showFirstLastButtons
		aria-label="Select page of periodic elements"
	>
	</mat-paginator>
</ng-container>
